<template>
	<div class="container">
		<h1>Meet The Band</h1>
		<div class="image-container" id="meet-photo">
			<img src="/assets/img/band-profile-640x480.jpg" alt="Group photo of 5 band members each holding a bluegrass musical instrument, dobro, guitar, banjo, mandolin, upright bass"/>
		</div>
		<div class="page-text">
			<p>Forged in the heart of Milwaukee’s Riverwest bluegrass community The Barred Owl Stringband performs early Americana tunes rooted in the days of yore.</p>
		</div>
	</div>
</template>

<script>
	
	export default {
		name: "Info",
		data() {
			
		},
		mounted(){
			
		},
		methods: {
			
		}
	};
</script>